// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5909cb1e","609":"d21288c1","625":"2eb1b8c0","649":"a99571ee","652":"ba9a0659","674":"c6e7866c","863":"b89c991c","872":"90d61cea","900":"15d961ea"}[chunkId] + ".chunk.js";
};